import React from 'react';
import ReactDOM from 'react-dom';

import {Provider} from 'react-redux';
import {App} from '@/app/App';
import store from '@/app/store';
import * as serviceWorker from './serviceWorker';
import 'semantic-ui-css/semantic.min.css';
import './styles/index.scss';

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
